import React from "react";
import { commingSoon } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";

function PlatformWiseInfo() {
  return (
    <>
      <div className="col-12 col-lg-4">
        <div className="card-box platform">
          <div className="card-title">
            <h2>{Constants.Platform_Wise_Info}</h2>
          </div>
          {commingSoon()}

          {/* <div className="platform__ranges blur-layer">
            <div className="platform__ranges__card">
              <p>
                25% <span>Website</span>
              </p>
              <div className="platform-range">
                <span className="range-value bg-purple"></span>
              </div>
            </div>
            <div className="platform__ranges__card">
              <p>
                75% <span>Website</span>
              </p>
              <div className="platform-range">
                <span className="range-value bg-yellow"></span>
              </div>
            </div>
            <div className="platform__ranges__card">
              <p>
                0% <span>Website</span>
              </p>
              <div className="platform-range">
                <span className="range-value "></span>
              </div>
            </div>
          </div> */}

          {/* <p className="platform__ranges__coming">Coming soon...</p> */}
        </div>
      </div>
    </>
  );
}

export default PlatformWiseInfo;
